import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { HalfCirclePoint } from '@/common/components/HalfCirclePoint/HalfCirclePoint';
import { PageLayout } from '@/common/components/PageLayout/PageLayout';
import { Translate } from '@/common/components/Translate/Translate';
import { ESInsuranceLearningCentre } from '@/common/containers/Dashboard/Insurance/components/ESInsuranceLearningCenter/ESInsuranceLearningCenter';
import { AnalyticsService } from '@/common/integrations/analytics/analytics.service';
import { IInsurancePolicy } from '@/common/integrations/menhir/employee/insurance/insurance.types';
import { MoneyUtils, defaultMoney } from '@coverflex-tech/hypernova-utils';
import { InsuranceHomeDetails } from './InsuranceHomeDetails/InsuranceHomeDetails';

export type TESInsuranceHomeProps = {
  activePolicy?: IInsurancePolicy;
  upcomingPolicy?: IInsurancePolicy;
};

export function ESInsuranceHome({
  activePolicy,
  upcomingPolicy,
}: TESInsuranceHomeProps) {
  const { t } = useTranslation();
  const [showLC, setShowLC] = useState(false);

  const exemptionAmount =
    activePolicy?.metadata?.exemptionAmount ?? defaultMoney;

  return (
    <PageLayout
      headerProps={{
        title: t('dashboard.insurance_detail.title'),
        infoButton: {
          onPress: () => {
            AnalyticsService.trackCustomEvent(
              'insurance_learning_center_button_clicked'
            );
            setShowLC(true);
          },
        },
        description:
          exemptionAmount?.amount > 0 ? (
            <HalfCirclePoint>
              <Translate
                key="health_insurance_description"
                i18nKey="dashboard.benefits.health_insurance.description.es"
                values={{
                  amount: MoneyUtils.moneyToString(exemptionAmount),
                }}
              />
            </HalfCirclePoint>
          ) : undefined,
      }}
    >
      <InsuranceHomeDetails
        activePolicy={activePolicy}
        upcomingPolicy={upcomingPolicy}
        hasMovements={false}
      />
      {showLC && <ESInsuranceLearningCentre onClose={() => setShowLC(false)} />}
    </PageLayout>
  );
}
